type IndefiniteArticle = 'a' | 'an' | 'A' | 'An'

/**
 * Get indefinite article for a string (a or an).
 * @param str The word to check
 * @param capitalize If true, returns 'A' or 'An'
 */
export function getIndefiniteArticle(str: string, capitalize = false): IndefiniteArticle {
  const article = ['a', 'e', 'i', 'o', 'u'].includes(str?.[0]?.toLowerCase()) ? 'an' : 'a'
  if (capitalize) {
    return (article.charAt(0).toUpperCase() + article.slice(1)) as IndefiniteArticle
  }
  return article as IndefiniteArticle
}
